<template>
  <BaseCenteredModal
    v-model:is-modal-open="localModalVisible"
    :title="'YouSign error details'"
    :size="'medium'"
    @close="autoClose"
  >
    <template #body>
      <json-pretty :data="errorDetails" />
    </template>
  </BaseCenteredModal>
</template>

<script>
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import { mapGetters, mapMutations } from 'vuex'
import JsonPretty from '@c/Utility/JsonPretty.vue'

export default {
  name: 'YouSignErrorDetailsModal',
  components: { JsonPretty, BaseCenteredModal },
  props: {},
  data() {
    return {
      localModalVisible: false
    }
  },
  computed: {
    ...mapGetters({
      errorDetails: 'electronicSignature/getErrorDetails'
    })
  },
  watch: {
    errorDetails(newValue, oldValue) {
      if (newValue && !this.localModalVisible) {
        this.localModalVisible = true
      }
    }
  },
  methods: {
    ...mapMutations({
      setErrorDetails: 'electronicSignature/setErrorDetails'
    }),
    autoClose() {
      if (!this.localModalVisible) {
        setTimeout(() => {
          this.setErrorDetails(null)
        }, 500)
      }
    }
  }
}
</script>
